export default __webpack_public_path__ + "static/media/67t.c4ca14c5.jpg";